export class MapPersistedState {
    center: [number, number];
    zoom: number;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}